import { defineMessages } from 'react-intl';

export default defineMessages({
    makeChanges: {
        id: 'ml.policychange.common.policychangebtn.makeChanges',
        defaultMessage: 'Make Changes'
    },
    cancelPolicy: {
        id: 'ml.policychange.common.policychangebtn.cancelPolicy',
        defaultMessage: 'Cancel Policy'
    },
    reinstatePolicy: {
        id: 'ml.policychange.common.policychangebtn.reinstatePolicy',
        defaultMessage: 'Reinstate Policy'
    },
    rewritePolicy: {
        id: 'ml.policychange.common.policychangebtn.rewritePolicy',
        defaultMessage: 'Rewrite Policy'
    },
    createManageBundle: {
        id: 'ml.policychange.common.policychangebtn.createManageBundle',
        defaultMessage: 'Create/Manage Bundle'
    },
    changeMyPolicy: {
        id: 'ml.policychange.common.policychangebtn.changeMyPolicy',
        defaultMessage: 'Change My Policy'
    },
    NonDrivers: {
        id: 'ml.policychange.common.policychangebtn.Non Drivers',
        defaultMessage: 'Non Drivers'
    },
    RentedTrailer: {
        id: 'ml.policychange.common.policychangebtn.Rented Trailer',
        defaultMessage: 'Rented Trailer'
    },
});
